import { useTranslation } from 'react-i18next';

export type Labels = {
  placeholderTitle: string;
  placeholderBody: string;
  errorMessage: string;
  retry: string;
};

export function useLabels(): Labels {
  const { t } = useTranslation();

  return {
    placeholderTitle: t(
      'web.admin.inspections.templateCustomize.v2.placeholderTitle'
    ),
    placeholderBody: t(
      'web.admin.inspections.templateCustomize.v2.placeholderBody'
    ),
    errorMessage: t('web.admin.inspections.templateCustomize.v2.errorMessage'),
    retry: t('web.admin.inspections.templateCustomize.v2.retry'),
  };
}
